module.exports = "https://coursera_assets.s3.amazonaws.com/images/d13b31ec28371195e2ae90c81c7b4b7b.png";